export default "__VITE_ASSET__bBBryga6__"